import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Term} from "../../../../../classes/term";

@Component({
    selector: 'kan-term-list',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanTermList {
    @Input() public terms: Term[];
    @Output() refresh: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }

    public emitRefresh(): void {
        this.refresh.emit();
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/term/list/component.ts